export default __webpack_public_path__ + "images/logo-eu.svg?85c03b0b6a1f48e7311156c99a15d0b8";